<template>
  <validation-observer ref="simpleRules">
    <project-packages-item-form />
    <project-packages-limit-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>
<script>
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ProjectPackagesItemForm from '@/views/Admin/Project_packages/ItemForm.vue'
import ProjectPackagesLimitForm from '@/views/Admin/Project_packages/limitForm.vue'

export default {
  name: 'EditPage',
  components: {
    ProjectPackagesLimitForm,
    ProjectPackagesItemForm,
    ValidationObserver,
    SaveButton,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['projectPackages/dataItem']
    },
    saveData() {
      return this.$store.getters['projectPackages/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push('/admin/project-packages')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
    },
  },
  beforeCreate() {
    this.$store.commit('projectPackages/RESET_DATA_ITEM')
  },
  created() {
    localize('tr')
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('projectPackages/getDataItem', this.$route.params.id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('projectPackages/saveData', this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
